import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector, getFormValues } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import ContentCardFooter from '../common/template/contentCardFooter';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Button from '../common/button/button';
import Form from '../common/form/form';
import LabelAndInput from '../common/form/labelAndInput';
import Select from '../common/form/select';
import LabelAndInputNumber from '../common/form/labelAndInputNumber';
import LabelAndInputDate from '../common/form/labelAndInputDate';
import ButtonTable from '../common/table/buttonTable';
import { setError } from '../common/toast/toast';
import imagemAdd from '../assets/images/icone_add_imagem.png';
import pdfAdd from '../assets/images/icone_add_pdf.png';
import pdfAdicionado from '../assets/images/icone_pdf_adicionado.png';
import LabelAndInputDateTime from '../common/form/labelAndInputDateTime';

import { setModoTela, initForm } from './testeQualidadeActions';

class TesteQualidadeForm extends Component {

    componentWillMount() {

		let initSeletorArquivo = () => {
			const fileSelectorArquivo = document.createElement('input');
			fileSelectorArquivo.setAttribute('type', 'file');
			fileSelectorArquivo.addEventListener("change", (data) => {

				let reader = new FileReader();
				let file = data && data.path && data.path[0] && data.path[0].files && data.path[0].files[0] ? data.path[0].files[0] : null;
				if (!file) {
					file = data && data.target && data.target.files && data.target.files[0] ? data.target.files[0] : null;
				}

				if (file) {

					if (!file.type.includes('application/pdf')
						&& !file.type.includes('image/png') && !file.type.includes('image/jpg') && !file.type.includes('image/jpeg')) {
						setError('Selecione apenas (.PDF, .PNG, .JPG e .JPEG)');
						return;
					}

					reader.onloadend = () => {


						let lista = (this.props.formularioValues.arquivos || []).map(item => item);
						lista.push({
							arquivo_base64: reader.result
						});

						this.props.initForm({
							...this.props.formularioValues,
							arquivos: lista
						});

						initSeletorArquivo();

					}

					reader.readAsDataURL(file);

				}
			});

			this.fileSelectorArquivo = fileSelectorArquivo;
		};

		initSeletorArquivo();

    }

    render() {

		let readOnly = this.props.excluir ? 'readOnly' : '';

        return (
			<ContentCard>
				<Form event={this.props.handleSubmit}>
					<ContentCardBody>
						<Row>
							
							<Field
								name='datahora_realizacao'
								component={LabelAndInputDateTime}
								label='Data/Hora' placeholder='Informe a data e hora'
								cols='12 4 4 3'
								readOnly={readOnly} />
							
							{this.props.formularioValues.local == 'unidade' &&
							<Field
								name='id_unidade'
								component={Select}
								options={this.props.listaUnidade}
								label='Unidade'
								cols='12 12 12 12'
								placeholder='Selecione o unidade'
								readOnly={readOnly} />}

							{this.props.formularioValues.local == 'cliente' &&
							<Field
								name='id_cliente'
								component={Select}
								options={this.props.listaCliente}
								label='Cliente'
								cols='12 12 12 12'
								placeholder='Selecione o cliente'
								readOnly={readOnly} />}
								
							{this.props.formularioValues.local == 'cliente' &&
							<Field
								name='id_endereco'
								component={Select}
								options={this.props.listaEndereco.filter(item => item.id_cliente == this.props.formularioValues.id_cliente)}
								label='Endereço'
								cols='12 12 12 12'
								placeholder='Selecione o endereço'
								readOnly={readOnly} />}
							
							<Field
								name='id_produto'
								component={Select}
								options={this.props.listaProduto}
								label='Produto'
								cols='12 12 12 12'
								placeholder='Selecione o produto'
								readOnly={readOnly} />

							<Field
								name='temperatura'
								component={LabelAndInputNumber}
								label='Temperatura' placeholder='Informe a temperatura'
								cols='12 6 4 3'
								casas={1}
								readOnly={readOnly} />

							<Field
								name='massa'
								component={LabelAndInputNumber}
								label='Massa' placeholder='Informe a massa'
								cols='12 6 4 3'
								casas={4}
								readOnly={readOnly} />

							<Field
								name='densidade'
								component={LabelAndInputNumber}
								label='Densidade' placeholder='Informe a densidade'
								cols='12 6 4 3'
								casas={4}
								readOnly={readOnly} />

							<Field
								name='coloracao'
								component={LabelAndInput}
								label='Coloração' placeholder='Informe a coloração'
								cols='12 12 12 12'
								readOnly={readOnly} />
							
							<Field
								name='resultado'
								component={LabelAndInput}
								label='Resultado' placeholder='Informe o resultado'
								cols='12 12 12 12'
								readOnly={readOnly} />

							<Field
								name='observacao'
								component={LabelAndInput}
								label='Observação' placeholder='Informe a observação'
								cols='12 12 12 12'
								readOnly={readOnly} />

							{this.props.formularioValues.local == 'unidade' &&
							<Field
								name='amostra_testenhuna'
								component={LabelAndInput}
								label='Amostra Testemunha' placeholder='Informe a amostra'
								cols='12 12 12 12'
								readOnly={readOnly} />}

							{this.props.formularioValues.local == 'unidade' &&
							<Field
								name='nota_fiscal'
								component={LabelAndInput}
								label='Nota Fiscal' placeholder='Informe a nota fiscal'
								cols='12 12 12 12'
								readOnly={readOnly} />}
													
						</Row>

						<Row>
							<Grid cols='12 12 12 12'>

								<Row style={{ paddingBottom: 16 }}>
									<Grid cols='12 12 12 12'>
										<label>Anexos</label>
									</Grid>
									{(this.props.formularioValues.arquivos || []).map(arquivo => (
										<div style={{ display: 'flex', flexDirection: 'column', marginLeft: 8 }}>
											<span class="btn btn-outline-primary fileinput-button dz-clickable">
												<img src={arquivo.arquivo_base64 ? pdfAdicionado : (arquivo.arquivo ? pdfAdicionado : pdfAdd)} style={{ height: 30 }} />
											</span>
											<div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingRight: 2, marginTop: 4 }}>
												<button
													type='button'
													class='btn btn-flat btn-outline-primary'
													style={{ width: '48%' }}
													disabled={arquivo.arquivo_base64 ?true : false}
													onClick={() => {
														window.open(`https://api-valedaserra.infinitum-ti.com/${arquivo.arquivo}`, '_blank');
													}}>
													<i class='fas fa-download'></i>
												</button>

												<button
													type='button'
													class='btn btn-flat btn-outline-danger'
													style={{ width: '48%' }}
													disabled={readOnly}
													onClick={() => {
														this.props.initForm({
															...this.props.formularioValues,
															arquivos: this.props.formularioValues.arquivos.filter(item => item != arquivo)
														});
													}}>
													<i class='fas fa-trash-alt'></i>
												</button>
											</div>
										</div>
									))}
									{!readOnly ? (
										<span class="btn btn-outline-primary fileinput-button dz-clickable" 
											style={{ marginLeft: 8 }}
											onClick={() => this.fileSelectorArquivo.click()}>
											<img src={pdfAdd} style={{ height: 30 }} />
										</span>
									) : null}
								</Row>

							</Grid>
						</Row>
					</ContentCardBody>
					<ContentCardFooter>
						<Row alignCenter>
							<Grid cols='6 6 4 3'>
								{this.props.excluir ? (
									<Button
										text='Excluir'
										submit type={'danger'}
										icon={'fa fa-trash'} />
								) : (
								<Button
									text='Salvar'
									submit
									type={'success'}
									icon={'fa fa-check'} />
								)}
							</Grid>
							<Grid cols='6 6 4 3'>
								<Button
									text='Voltar'
									type={'warning'}
									icon={'fa fa-chevron-left'}
									event={() => this.props.setModoTela('lista')} />
							</Grid>
						</Row>
					</ContentCardFooter>

				</Form>
			</ContentCard>
        )
    }


}

TesteQualidadeForm = reduxForm({form: 'testeQualidadeForm', destroyOnUnmount: false})(TesteQualidadeForm);
const mapStateToProps = state => ({
	sessao: state.auth.testeQualidade,
	formularioValues: getFormValues('testeQualidadeForm')(state),
	registro: state.testeQualidade.registro,	
	listaMotorista: state.testeQualidade.listaMotorista,
    listaUnidade: state.testeQualidade.listaUnidade,
    listaCliente: state.testeQualidade.listaCliente,
    listaEndereco: state.testeQualidade.listaEndereco,
    listaProduto: state.testeQualidade.listaProduto
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(TesteQualidadeForm);
